import React, { useEffect, useState } from "react";
import { Class, slotDataType } from "src/Utils/Types";
import PackageCalenderItem from "./Calender/PackageCalenderItem";
import { useAppSelector } from "src/Redux/hooks";

const PackageSingleClassAppointment = ({
  classes,
  slots,
  step,
  prevStep,
  setStep,
  setSlotsData,
}: {
  classes: Class;
  slots: number;
  step: number;
  setStep: () => void;
  prevStep: () => void;
  setSlotsData: (d: slotDataType[]) => void;
}) => {
  const [count, setCount] = useState<number>(1);
  const [data, setData] = useState<slotDataType[]>([]);
  const [message, setMessgage] = useState<string>("");
  const [addMore, setAddMore] = useState<boolean>(false);
  const [selectedDates, setSelectedDates] = useState<string[]>([]);

  const slotss = useAppSelector((state) => state.app?.slots);
  const selectedPackage = useAppSelector((state) => state.app?.selectedPackage);

  useEffect(() => {
    if (
      data?.length > 0 &&
      data[data?.length - 1].time &&
      data[data?.length - 1].date
    )
      setAddMore(true);
    else setAddMore(false);
    setSlotsData(data);
  }, [data]);

  // Update data at specific index and track selected dates
  const updateDataAtIndex = (newData: slotDataType, index: number) => {
    setData((prevData) => {
      const newArray = [...prevData];
      // If the index exists, update it. Otherwise, add the new data
      if (index < newArray.length) {
        // Remove old date from selectedDates if it exists
        if (newArray[index]?.date) {
          setSelectedDates((prev) =>
            prev.filter((date) => date !== newArray[index].date)
          );
        }
        newArray[index] = newData;
      } else {
        newArray[index] = newData;
      }
      // Add new date to selectedDates if it exists
      if (newData.date) {
        setSelectedDates((prev) => [...prev, newData.date]);
      }
      return newArray;
    });
  };

  return (
    <div className="p-8">
      <div className="mb-4">
        <h3 className="text-lg font-bold capitalize">{classes?.name}</h3>
        <p className="text-sm text-gray-400">{classes?.description}</p>
      </div>
      <h4>Appointments:</h4>
      {Array.from({ length: count }, (_, index) => (
        <PackageCalenderItem
          key={index}
          classes={classes}
          sendDataToParent={(newData) => updateDataAtIndex(newData, index)}
          index={index}
          selectedDates={selectedDates}
        />
      ))}
      {slotss?.length + count < (selectedPackage?.days ?? 0) && addMore && (
        <button
          className="button mt-4"
          onClick={() => {
            if (slotss?.length + count >= (selectedPackage?.days ?? 0)) {
              setMessgage("Reached Maximum Slots");
              setTimeout(() => {
                setMessgage("");
              }, 1500);
              return;
            }
            setCount((prev) => prev + 1);
          }}
        >
          {message || "Add More"}
        </button>
      )}
    </div>
  );
};

export default PackageSingleClassAppointment;
